<template>
  <div class="detail_box">
    <div class="detail_window">
        <!-- 头部 -->
        <div class="detail_header">
            <div class="detail_header_left">
                <div>详情</div>
            </div> 
            <span @click="closeWindow()">×</span>
        </div>

        <!-- 内容 -->
        <div class="detail_content">
            <div class="detail_content_box">
                <div class="detail_content_item freePic" v-for="(item,index) in detailDataList" :key="index" >
                    <p :title="item.title">{{item.title}} :</p>
                    <template v-if="item.type == myConst.detailType.text">
                        <span :title="item.val">{{ item.val }}</span>
                    </template>
                    <template v-if="item.type == myConst.detailType.textarea">
                        <div class="textarea_box" :title="item.val">{{ item.val }}</div>
                    </template>
                    <template v-if="item.type == myConst.detailType.time">
                        <div class="textarea_box" :title="item.val">{{ longToDate(item.val) }}</div>
                    </template>
                    <template v-if="item.type == myConst.detailType.image">
                            <el-image  :src="item.val" @click="imgClick"></el-image>
                            <el-dialog class="dialog_img" :visible.sync="dialogVisible" :modal="false">
                                <el-image width="100%" :src="item.val" alt="" />
                            </el-dialog>
                    </template>
                </div>
            </div>
            
        </div>

        <!-- 底部 -->
        <div class="detail_footer">
            <div class="footer_box">
                <button class="button_style0" @click="closeWindow()">
                    <i class="iconfont icon-quxiao1"></i>取消
                </button>
                <button class="button_style0" @click="resetClick">
                    <i class="iconfont icon-zhongzhi3"></i>重置
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import fun from "@/util/util";
import {mapState, mapMutations } from 'vuex';
import myConst from "@/util/my-const";
export default {
    data(){
        return {
            myConst,
            dialogVisible: false,
        }
    },
    computed:{
        ...mapState('detailWindow', ['detailDataList'])
    },
    methods:{
        ...mapMutations('detailWindow', ['closeDetailWindow']),
        //转化日期格式
        longToDate(val) {
            return fun.longToDate(val);
        },

        //关闭弹窗 
        closeWindow(){
            this.closeDetailWindow()
        },

        // 重置按钮
        resetClick(){
            
        },

        //图片点击事件
        imgClick(){
            this.dialogVisible = true
        }

    }
}
</script>

<style scoped>
.detail_box{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.detail_window{
    width: 102.4rem;
    height: 76.8rem;
    background-color: transparent;
    background-image: url(~@/assets//images/iems/show_win_bag.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.detail_header{
    margin-top: 1rem;
    height: 3.2rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* box-sizing: border-box; */
    position: relative;
}
.detail_header>.detail_header_left{
    width: 90%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: bold;
}
.detail_header > span{
    position: absolute;
    height: 100%;
    width: 5rem;
    font-size: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 0.5rem;
    top: 1rem;
    color: #909399;
    cursor: pointer;
}
.detail_content{
    height: 61rem;
    margin-top: 2rem;
    padding: 0rem 2rem;
    color: #00dafc;
    font-size: 1.4rem;
    box-sizing: border-box;
}
.detail_content_box{
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-between;
}
.detail_content_item{
    display: flex;
    /* align-items: center; */
    /* height: 4rem; */
    align-items: flex-start;
    padding: 1.8rem 0;
    width: 32%;
}
.detail_content_item span{
    vertical-align: top;
    font-style: italic;
    text-align: left;
    /*1. 先强制一行内显示文本*/
    white-space: nowrap;
    /*2. 超出的部分隐藏*/
        overflow: hidden;
    /*3. 文字用省略号替代超出的部分*/
    text-overflow: ellipsis;
}
.detail_content_item > p{
    color: #fff;
    width: 7rem;
    padding-right: 0.5rem;
    text-align: left;
    /*1. 先强制一行内显示文本*/
    white-space: nowrap;
    /*2. 超出的部分隐藏*/
        overflow: hidden;
    /*3. 文字用省略号替代超出的部分*/
    text-overflow: ellipsis;
}
.detail_content_item > .textarea_box{
    flex: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 定义文本的行数 */
    /*2. 超出的部分隐藏*/
    overflow: hidden;
    /*3. 文字用省略号替代超出的部分*/
    text-overflow: ellipsis;
}
.detail_box .dialog_table{
    margin-left: 4rem;
    margin-top: 1.8rem;
}
.detail_footer{
    flex: 1;
    width: 100%;
    padding-bottom:2rem ;
    box-sizing: border-box;
}
.footer_box{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.footer_box .button_style0{
    margin-right: 3rem;
}
::v-deep .detail_content_item>.el-image{
    width: 20rem;
    height: 10rem;
    cursor: pointer;
}
::v-deep .dialog_img .el-dialog{
  width: 150rem;
  height: 90rem;
  background: none;
  margin-top: 0 !important;
  padding: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
::v-deep .dialog_img .el-dialog__header{
    height: 2rem;
}
::v-deep .dialog_img .el-dialog__body{
    flex: 1;
    overflow: hidden;
}
::v-deep .dialog_img .el-image{
    width: 150rem;
    height: auto;
    max-height: 100%;

}
::v-deep .el-dialog__headerbtn{
    top: 6rem;
    right: 3rem;
    color: #000;
    z-index: 9999;
}
</style>
